import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboFiltroVerracosLimpieza`, method: 'GET', body: null, token: token})
}